import { FC } from "react";
import { Box } from "@mui/material";
import { TIMELINES_DATA } from "./data";
import TimeLineItem from "../TimeLineItem";

import ImgBg from "../../assets/images/about/timelines_bg.svg";

interface Props {
  inMobile: boolean;
}

const TimeLines: FC<Props> = ({ inMobile }) => {
  return (
    <Box position="relative" py={4} mx={{ xl: -20 }}>
      {inMobile ? null : (
        <Box
          sx={{
            position: "absolute",
            top: "20%",
            left: "4vw",
          }}
        >
          <img src={ImgBg} alt="background" />
        </Box>
      )}
      {TIMELINES_DATA.map((data) => (
        <TimeLineItem key={data.id} {...data} inMobile={inMobile} />
      ))}
    </Box>
  );
};

export default TimeLines;
